


























































import {
  Vue, Component, Prop, Emit,
} from 'vue-property-decorator';
import ModalComponent from '@/shared/modal/modal.component.vue';
import ModalOptions from '@/shared/modal/modal-options.entity';

@Component({
  components: {
    ModalComponent,
  },
})
export default class HomeMcpDetailsModal extends Vue {
  @Prop({ required: true }) value!: boolean;

  options: ModalOptions = {
    title: 'MCP do Gestão de Pessoas',
    showOk: true,
    labelOk: 'Entendi',
    width: 720,
  };

  examples: string[] = [
    'Qual é o meu saldo de férias?',
    'Quem é o meu líder e qual é o meu centro de resultado?',
    'Mostre a DRD do meu papel.',
    'Liste meus planos de PDI em andamento.',
    'Crie um plano no meu PDI para estudar Kubernetes até dezembro.',
    'Quem na DB1 tem conhecimento em Flutter?',
    'Quem faz aniversário este mês?',
    'Quem do meu time tem férias programadas no próximo mês?',
  ];

  @Emit('close')
  close(): void {}
}
